export default __webpack_public_path__ + "static/media/push34.46dd1344.gif";